import { appInsights } from "AppInsights";
import ReactGA from "react-ga4";
import hotjar from "static/scripts/hotjar";
import { deleteCookies } from "utils/cookieHelper";

import featureFlags from "./featureFlags";

const getGaMeasurementId = (): string => {
  if (process.env.REACT_APP_ENV_PREFIX == "dev") {
    return "G-M1P4L6PE8F";
  }

  if (process.env.REACT_APP_ENV_PREFIX == "test") {
    return "G-JNCQD4CTQC";
  }

  if (process.env.REACT_APP_ENV_PREFIX == "prod") {
    return "G-7Y75T7CD60";
  }

  return "";
};

const HOTJAR_SITE_ID = 2686849;
const HOTJAR_SNIPPET_VERSION = 6;
const GOOGLE_ANALYTICS_MEASUREMENT_ID = getGaMeasurementId();
const HOTJAR_RESOURCES_PATTERN = /^https?:\/\/(static|script)\.hotjar\.com.+$/;
const GOOGLE_ANALYTICS_PATTERN = /^https?:\/\/www.google-analytics.com\/.+$/;
const HOTJAR_SESSION_STORAGE_ITEMS = [
  "_hjRecordingEnabled",
  "_hjRecordingLastActivity",
  "hjViewportId",
];

const removeHotjarSessionStorage = (): void => {
  HOTJAR_SESSION_STORAGE_ITEMS.forEach((item) =>
    sessionStorage.removeItem(item)
  );
};

export const deleteAnalyticsScripts = (
  analyticsResourcePattern: RegExp
): void => {
  const head = document.getElementsByTagName("head")[0];
  const scriptsArray = Array.from(head.getElementsByTagName("script"));

  scriptsArray.forEach((script) => {
    if (script.src.match(analyticsResourcePattern)) {
      head.removeChild(script);
    }
  });
};

const disableHotjarAnalytics = (): void => {
  deleteAnalyticsScripts(HOTJAR_RESOURCES_PATTERN);
  removeHotjarSessionStorage();
};

const disableGoogleAnalytics = (): void => {
  deleteAnalyticsScripts(GOOGLE_ANALYTICS_PATTERN);
  deleteCookies("_ga");
};

export const initialiseAnalytics = (): void => {
  if (featureFlags.hotjar_analytics) {
    hotjar(HOTJAR_SITE_ID, HOTJAR_SNIPPET_VERSION);
  } else {
    disableHotjarAnalytics();
  }
  if (featureFlags.google_analytics) {
    ReactGA.initialize(GOOGLE_ANALYTICS_MEASUREMENT_ID);
  } else {
    disableGoogleAnalytics();
  }
  appInsights.getCookieMgr().setEnabled(true);
};

export const disableAnalytics = (): void => {
  disableHotjarAnalytics();
  disableGoogleAnalytics();
  appInsights.getCookieMgr().setEnabled(false);
};
